module.exports = __webpack_public_path__ + "img/fantasy-user-illustration.7b7a9977.png";